import React from 'react';
import useSheet from '../../../../../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../../../../../mobile/structural/sheet/sheetTypes';
import SheetContainer, { Content, Overlay, Sheet } from '../../../../../../../mobile/structural/sheet';

// Components
import MobileBoardEditorPermissionSheetContent from './MobileBoardEditorPermissionSheetContent';

// Types
import { MNUser } from '../../../../../../../../common/users/userModelTypes';
import { MNElement } from '../../../../../../../../common/elements/elementModelTypes';

// Styles
import './MobileBoardEditorPermissionSheet.scss';

type MobileBoardEditorPermissionSheetProps = {
    permission: number;
    user: MNUser;
    editable: boolean;
    currentBoardEditors: {
        sharedBoard: MNElement;
        userId: string;
        user: MNUser;
    }[];
    userId: string;
    isCurrentUser: boolean;
};

const MobileBoardEditorPermissionSheet = (props: MobileBoardEditorPermissionSheetProps) => {
    const { permission, user, editable, currentBoardEditors, userId, isCurrentUser } = props;
    const sheetProps = useSheet(SheetId.BoardEditorPermission, userId);

    return (
        <SheetContainer className="MobileBoardEditorsPermissionSheet" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <MobileBoardEditorPermissionSheetContent
                        permission={permission}
                        user={user}
                        editable={editable}
                        currentBoardEditors={currentBoardEditors}
                        userId={userId}
                        isCurrentUser={isCurrentUser}
                        dispatchCloseSheet={sheetProps.dispatchCloseSheet}
                        dispatchUpdateActiveSnapPoint={sheetProps.dispatchUpdateActiveSnapPoint}
                        activeSnapPoint={sheetProps.activeSnapPoint}
                    />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileBoardEditorPermissionSheet;
